<template>
  <v-container
    fluid
    fill-height
  >
    <v-layout
      row
      align-center
      justify-center
      >

      <div class="sk-circle" v-if="loading">
        <div class="sk-circle1 sk-child"></div>
        <div class="sk-circle2 sk-child"></div>
        <div class="sk-circle3 sk-child"></div>
        <div class="sk-circle4 sk-child"></div>
        <div class="sk-circle5 sk-child"></div>
        <div class="sk-circle6 sk-child"></div>
        <div class="sk-circle7 sk-child"></div>
        <div class="sk-circle8 sk-child"></div>
        <div class="sk-circle9 sk-child"></div>
        <div class="sk-circle10 sk-child"></div>
        <div class="sk-circle11 sk-child"></div>
        <div class="sk-circle12 sk-child"></div>
      </div>

      <v-card
        v-if="notFound"
        text
        color="transparent"
        width="100%"
        max-width="600"
      >
        <v-card-text>
          <v-layout row wrap align-center>
            <v-flex
              xs12
              class="display-2 font-weight-light text-xs-center">
              <div
                class="display-4 font-weight-light text-xs-center grey--text mb-5">
                <i class="fas fa-ban"></i>
              </div>
              <div class="headline font-weight-light text-xs-center">
                Preview not found
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-card
        v-if="preview"
        class="preview-iframe"
        text
        width="100%"
        max-width="600"
      >
        <div
          class="resp-container"
          v-html="preview"
        />
      </v-card>

    </v-layout>
  </v-container>
</template>

<script>
  import firebase from '@/firebase/main'
  export default {
    name: 'AdPreviewShow',
    data () {
      return {
        preview: null,
        notFound: false,
        loading: true
      }
    },
    mounted () {
      this.getPreview()
    },
    methods: {
      getPreview () {
        const id = this.$route.params.id
        return new Promise(resolve => {
          resolve(firebase.Previews.getPreviewById(id))
        })
          .then(res => {
            if (res) {
              this.preview = res.preview
            } else {
              this.notFound = true
            }
            this.loading = false
          })
      }
    }
  }
</script>
<style>
  .preview-iframe {
    width: 546px;
    height: auto!important;
    overflow: hidden;
  }
  .resp-container {
    position: relative;
    padding-top: 100%;
    width: 100%;
    height: 100%;
  }
  .resp-container iframe {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
</style>
